import dayjs from "dayjs";

export const serverToLocalDate = (dateString: string) => {
  return new Date(dateString);
};

export const localDateToServer = (date: Date) => {
  return date.toISOString();
};

export const localCurrentTimeToServer = () => {
  const date = new Date();
  return date.toISOString();
};

export const formatDate = (date: Date) => {
  return dayjs(date).format("LLL");
};

export const formatServerToLocalDateAsTimeOnly = (dateString: string) => {
  return dayjs(serverToLocalDate(dateString)).format("LT");
};

export const formatServerToLocalDate = (dateString: string) => {
  return dayjs(serverToLocalDate(dateString)).format("LLLL");
};

export const formatServerToLocalDateTz = (dateString: string) => {
  return dayjs(serverToLocalDate(dateString)).format("LLLL z");
};

export function convertToIso8601WithLocalTimezone(
  dateTimeString: string | undefined,
  format: string = "YYYY-MM-DD hh:mm:ss"
): string | undefined {
  if (!dateTimeString) {
    return undefined;
  }
  const dayjsObj = dayjs(dateTimeString, format);
  // Check if parsing was successful
  if (!dayjsObj.isValid()) {
    console.error(
      `Invalid date-time string or format: ${dateTimeString}, ${format}`
    );
    throw new Error(
      `Invalid date-time string or format: ${dateTimeString}, ${format}`
    );
  }

  // To get the ISO 8601 string with the local timezone offset,
  // we can use .format() with the ISO 8601 format string 'YYYY-MM-DDTHH:mm:ssZ'.
  // Day.js will automatically include the local offset (+HH:MM or -HH:MM).
  // The 'Z' token in Day.js's format method will correctly output the local offset.
  return dayjsObj.format("YYYY-MM-DDTHH:mm:ssZ");
}
